/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WorkorderAddSignatureCommandFromJSON(json) {
    return WorkorderAddSignatureCommandFromJSONTyped(json, false);
}
export function WorkorderAddSignatureCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'photoName': !exists(json, 'photoName') ? undefined : json['photoName'],
        'signatureDataUri': !exists(json, 'signatureDataUri') ? undefined : json['signatureDataUri'],
    };
}
export function WorkorderAddSignatureCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderId': value.orderId,
        'photoName': value.photoName,
        'signatureDataUri': value.signatureDataUri,
    };
}
